import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useStateHandler from '@/hooks/useStateHandler';
import AuthService from '@/services/auth.service';

function getBridgeTicket() {
  if (typeof window === 'undefined') return null;
  return new URLSearchParams(window.location.hash.slice(1)).get('cross_app_ticket');
}

function isSafeContinuationPath(value) {
  return typeof value === 'string' && value.startsWith('/artwork/');
}

export default function CrossAppAuthBridge() {
  const navigate = useNavigate();
  const { stateHandler } = useStateHandler();
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;

    async function redeemTicket() {
      const ticket = getBridgeTicket();
      if (!ticket) {
        setError('This sign-in link is invalid or has expired.');
        return;
      }

      try {
        const { response, data } = await AuthService.redeemSuarteFrontendTicket(ticket);
        if (!response?.ok || !data?.custom_token || !data?.user_session) {
          throw new Error(data?.error_message || 'Unable to start the Suarte session.');
        }

        await AuthService.initUserSession(stateHandler, null, data);
        if (!active) return;

        const continuationPath = isSafeContinuationPath(data.continuation_path)
          ? data.continuation_path
          : '/';
        window.history.replaceState(null, '', continuationPath);
        navigate(continuationPath, { replace: true });
      } catch (bridgeError) {
        if (active) {
          setError(bridgeError?.message || 'Unable to start the Suarte session.');
        }
      }
    }

    void redeemTicket();
    return () => {
      active = false;
    };
  }, [navigate, stateHandler]);

  return (
    <main aria-live="polite" role="status">
      <p>{error || 'Opening collectors…'}</p>
    </main>
  );
}
